import { heights as lineHeight } from './line-height';

const bodyTextFontSize = {
    s: 14,
    m: 16,
    l: 18,
};

const subtitleFontSize = {
    s: 16,
    m: 18,
    l: 22,
};

const fontSize = {
    'body-text': bodyTextFontSize,
    caption: bodyTextFontSize,
    subtitle: subtitleFontSize,
};

export const sizes = { fontSize, lineHeight };
